import { render, staticRenderFns } from "./CustomDrawer.vue?vue&type=template&id=54045b89&scoped=true"
import script from "./CustomDrawer.vue?vue&type=script&lang=js"
export * from "./CustomDrawer.vue?vue&type=script&lang=js"
import style0 from "./CustomDrawer.vue?vue&type=style&index=0&id=54045b89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54045b89",
  null
  
)

export default component.exports